import React from 'react';
import styled from 'styled-components';
import { Link } from '@lt/components';

import type { EmailProvider, ProviderConfig } from './types';
import { mapProviderToConfig } from './config';

interface Props {
  email: string;
}

function mapEmailToConfig(email: string): ProviderConfig | undefined {
  const [, domain] = email.split('@');
  const provider = domain?.split('.')[0] as EmailProvider;

  return mapProviderToConfig[provider];
}

export const EmailButton: React.FC<Props> = ({ email }) => {
  const config = mapEmailToConfig(email);

  if (!config) {
    return null;
  }

  return (
    <StyledLink href={config.url}>
      {config.icon}
      <Text>Перейти в {config.name}</Text>
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  color: #17181a;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  box-sizing: border-box;
`;

const Text = styled.span`
  margin-left: 8px;
`;
